var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 195,
    viewBox: "0 0 541 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518.185 169.164C576.524 311.942 515.696 478.315 382.322 540.767C248.949 603.22 93.5345 538.103 35.1955 395.325C-23.1435 252.546 37.6843 86.1734 171.058 23.7208C304.432 -38.7318 459.846 26.3852 518.185 169.164Z",
    fill: "url(#paint0_linear_844_7461)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.767 199.747C180.744 221.712 171.388 247.308 150.87 256.918C130.352 266.528 106.441 256.512 97.4641 234.547C88.4871 212.582 97.8431 186.986 118.361 177.376C138.88 167.766 162.79 177.782 171.767 199.747Z",
    fill: "url(#paint1_linear_844_7461)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M418.041 80.8545C423.201 88.6881 422.429 98.7789 416.317 103.393C410.205 108.007 401.067 105.397 395.907 97.5638C390.747 89.7302 391.519 79.6393 397.631 75.0252C403.743 70.4111 412.881 73.0209 418.041 80.8545Z",
    fill: "url(#paint2_linear_844_7461)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.994 10.2724C269.511 15.1165 260.465 20.2028 248.788 21.6331C237.111 23.0635 227.225 20.2961 226.707 15.4521C226.189 10.6081 235.235 5.52174 246.913 4.09142C258.59 2.6611 268.476 5.42844 268.994 10.2724Z",
    fill: "url(#paint3_linear_844_7461)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.756 12.4212C189.514 16.2739 179.031 25.6252 164.342 33.308C149.653 40.9908 136.32 44.0957 134.562 40.2431C132.803 36.3904 143.286 27.0391 157.975 19.3563C172.664 11.6735 185.997 8.56855 187.756 12.4212Z",
    fill: "#B3D73B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.062 17.4844C193.096 24.1326 183.648 35.7502 168.959 43.4331C154.27 51.1159 139.902 51.9547 136.868 45.3065C133.834 38.6584 143.282 27.0408 157.971 19.3579C172.66 11.675 187.028 10.8362 190.062 17.4844Z",
    fill: "#B3D73B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.348 13.2166C179.86 14.3375 171.935 19.6083 161.647 24.989C151.359 30.3698 142.605 33.823 142.093 32.702C141.582 31.581 149.507 26.3103 159.794 20.9296C170.082 15.5488 178.837 12.0956 179.348 13.2166Z",
    fill: "#480307"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M501.582 126.318C498.65 128.457 489.661 119.808 481.505 106.999C473.348 94.1898 469.112 82.0719 472.043 79.9326C474.975 77.7932 483.964 86.4425 492.12 99.2514C500.277 112.06 504.513 124.178 501.582 126.318Z",
    fill: "url(#paint4_linear_844_7461)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M497.736 129.125C492.678 132.817 481.965 125.426 473.808 112.617C465.651 99.8086 463.14 86.4325 468.198 82.741C473.257 79.0494 483.97 86.4402 492.127 99.2488C500.283 112.057 502.795 125.433 497.736 129.125Z",
    fill: "url(#paint5_linear_844_7461)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M499.861 118.53C499.008 119.153 493.685 112.385 487.972 103.414C482.259 94.443 478.32 86.666 479.173 86.0435C480.026 85.421 485.348 92.1888 491.061 101.16C496.774 110.131 500.714 117.908 499.861 118.53Z",
    fill: "#340409"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M317.101 59.7814C317.101 68.7719 305.753 76.0601 291.755 76.0601C277.758 76.0601 266.41 68.7719 266.41 59.7814C266.41 50.7909 277.758 43.5026 291.755 43.5026C305.753 43.5026 317.101 50.7909 317.101 59.7814Z",
    fill: "#8B0F19"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_844_7461",
    x1: 171.058,
    y1: 23.7223,
    x2: 407.619,
    y2: 528.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660C14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23070C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_844_7461",
    x1: 118.362,
    y1: 177.377,
    x2: 154.762,
    y2: 255.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A121D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_844_7461",
    x1: 397.632,
    y1: 75.0261,
    x2: 418.056,
    y2: 102.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A21421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_844_7461",
    x1: 246.912,
    y1: 4.09208,
    x2: 249.057,
    y2: 21.6008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#360B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1141F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_844_7461",
    x1: 469.17,
    y1: 76.0596,
    x2: 507.713,
    y2: 122.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600B13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_844_7461",
    x1: 465.124,
    y1: 79.0144,
    x2: 502.528,
    y2: 126.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A0C15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600B13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg82);
export default __webpack_public_path__ + "static/media/82.8a5ecc885db5000dc21a9b7393accf2e.svg";
export { ForwardRef as ReactComponent };